import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BasicInput, BaasicButton, BaasicModal } from "core/components";
import { FacilityOrderNewFlowConfirmModal } from "application/facility-order-new-flow/components";
import { Button } from "@progress/kendo-react-buttons";
function NikoPatientInformationBarTemplate({ nikoPatientInformationBarViewStore, disabled }) {
  const {
    isEditMode,
    form,
    genderStore,
    goToNikoHealth,
    nikoPatient,
    changeEditMode,
    facilityOrderNewFlowConfirmModal,
    showVisibilityOption,
    isStatusBarVisible,
    changeMenuVisibility,
    disableEditMode
  } = nikoPatientInformationBarViewStore;
  return (
    <form onSubmit={form.onSubmit}>
      {isStatusBarVisible || !showVisibilityOption ?
        <div className="patient__bar is-grey u-mar--left--tny">
          {showVisibilityOption && <Button className="btn is-expand is-bar" icon="u-icon u-icon--xmed u-icon--patient-back" onClick={() => changeMenuVisibility()} />
            // data-tooltip-content="Hide patient info" data-tooltip-id={"patientInformationTip" + patient.id} 
          }
          <div className="patient__group">
            <div>
              <i onClick={() => goToNikoHealth()} disabled={disabled} className={`u-icon u-icon--lrg u-mar--right--tny u-icon--insurance-external-link`} />
              <span className={`patient__brighttree`}>{nikoPatient.displayId}</span>
            </div>
            <span className="patient__group__divider">|</span>
            {isEditMode && (
              <div className="u-flex--primary u-flex--no-wrap u-flex--gap--1-5">
                <i className="u-icon u-icon--lrg u-icon--patient-name"></i>
                <div className="patient__name">
                  <BasicInput disabled={disabled} field={form.$("lastName")} />
                </div>
                <div className="patient__name">
                  <BasicInput disabled={disabled} field={form.$("firstName")} />
                </div>
                <span className="patient__group__divider">|</span>
              </div>
            )}
            <div className="u-flex--primary u-flex--no-wrap">
              <i className="u-icon u-icon--lrg u-icon--patient-user u-mar--right--tny"></i>
              {isEditMode ? <BaasicFieldDropdown disabled={disabled} field={form.$("gender")} store={genderStore} /> : <span>{form.$("gender").value}</span>}
            </div>
            <span className="patient__group__divider">|</span>

            <div className="u-flex--primary u-flex--no-wrap">
              <i className="u-icon u-icon--lrg u-icon--patient-ssn u-mar--right--tny"></i>
              {isEditMode ? <BasicInput disabled={disabled} field={form.$("ssn")} /> : <span>{form.$("ssn").value}</span>}
            </div>
            <span className="patient__group__divider">|</span>

            <div className="u-flex--primary u-flex--no-wrap">
              <i className="u-icon u-icon--lrg u-icon--patient-camera u-mar--right--tny"></i>
              {isEditMode ? <BasicInput disabled={disabled} field={form.$("dateOfBirth")} /> : <span>{form.$("dateOfBirth").value}</span>}
            </div>
          </div>
          {isEditMode ? (
            <div className="u-flex--primary u-flex--no-wrap u-flex--gap--1-5">
              <BaasicButton
                type="submit"
                onlyIcon={true}
                showTooltip={false}
                className="btn btn--icon ex-hover"
                onClick={form.onSubmit}
                disabled={form.submitting || form.validating || disabled}
                icon={form.submitting || form.validating ? "u-icon u-icon--xmed u-icon--sync u-rotate--login" : "u-icon u-icon--lrg u-icon--patient-check"}
              />
              <BaasicButton
                onlyIcon={true}
                showTooltip={false}
                className="btn btn--icon ex-hover"
                icon="u-icon u-icon--lrg u-icon--patient-close"
                onClick={() => changeEditMode(true)}
                disabled={form.submitting || form.validating || disabled}
              />
            </div>
          ) : (
            !disableEditMode &&
              <BaasicButton
                onlyIcon={true}
                showTooltip={false}
                className="btn btn--icon is-expand"
                icon="u-icon u-icon--med u-icon--edit-alt--primary"
                onClick={() => changeEditMode()}
                disabled={form.submitting || form.validating || disabled}
              />
          )}
        </div>
        :
        <React.Fragment>
          {/* <ReactTooltip positionStrategy="fixed" id={"patientInformationTip" + patient.id} place="top" /> */}
          {/* data-tooltip-content="View patient info" data-tooltip-id={"patientInformationTip" + patient.id} /> */}
          {showVisibilityOption &&
            < Button className="btn is-expand u-mar--left--sml is-bar" icon="u-icon u-icon--xmed u-icon--patient-forward" onClick={() => changeMenuVisibility()} />
          }
        </React.Fragment>
      }
      <BaasicModal modalParams={facilityOrderNewFlowConfirmModal} className="modal__content modal--sml">
        <FacilityOrderNewFlowConfirmModal />
      </BaasicModal>
    </form>
  );
}

NikoPatientInformationBarTemplate.propTypes = {
  nikoPatientInformationBarViewStore: PropTypes.object,
  disabled: PropTypes.bool,
};

export default defaultTemplate(NikoPatientInformationBarTemplate);
